import { RootState } from '../store'
import { UserState } from '../slices/userSlice'

export const selectUser = (state: RootState): UserState => state.user
export const selectFavoriteProducts = (state: RootState): number[] => state.user?.product_ids ?? []
export const selectIsAuthenticated = (state: RootState): boolean => state.user !== null
